'use strict';
var commonBoutique = require('./_commonBoutiqueCN');

function noBorderNote(data) {
    var note = data.marker[0].note;
    if (note != null && note !== undefined && note !== '') {
        $('.js-noBorder-note').addClass('cc-boutique-noBorderBottom');
    }
}
module.exports = {
    telephonLink: function() {
        $(document).on('click', '.js-telephone-boutique', function(e) {
            e.stopPropagation();
        });
    },
    singleBoutiques: function () {
        $(document).ready(function () {
            var url = $('.cc-singleBoutique-details').data('getmarker');
            var boutiqueID = $('.cc-singleBoutique-details').data('boutiqueid');
            var countryCode = null;
            var singleBoutique = true;
            $.ajax({
                url: url,
                method: 'GET',
                data: {
                    countryCode: countryCode,
                    boutiqueID: boutiqueID
                },
                success: function (data) {
                    commonBoutique.createSingleMap(data.marker, singleBoutique, countryCode);
                    noBorderNote(data);
                }
            });
        });
    },
    resizeOnTablet: function() {
        $(window).on('resize', function () {
            var mapfill = $('.js-map .cc-icon').data('mapsfill');
            var galleryStroke = $('.js-img .cc-icon').data('gallerystroke');
            if ($(this).width() > 767.98 && $(this).width() < 1199.98) {
                $('.cc-images-only-mobile-visible').css({ display: 'none', visibility: 'hidden' });
                $('#mapBaidu').css({ display: 'block', visibility: 'visible' });
                if ($('.js-img').hasClass('cc-active')) {
                    $('.js-map').addClass('cc-active');
                    $('.js-img').removeClass('cc-active');
                    $('.cc-maps-icon').attr('xlink:href', mapfill);
                    $('.cc-gallery-icon').attr('xlink:href', galleryStroke);
                }
            }
        });
    },

    // cambio visuale da mappa ad immagine
    switchMobile: function () {
        var galleryStroke = $('.js-img .cc-icon').data('gallerystroke');
        var galleryFill = $('.js-img .cc-icon').data('galleryfill');
        var mapStroke = $('.js-map .cc-icon').data('mapsstroke');
        var mapfill = $('.js-map .cc-icon').data('mapsfill');
        $(document).on('click', '.js-map', function () {
            if (!$('.js-map').hasClass('cc-active')) {
                $('.cc-images-only-mobile-visible').css({ display: 'none', visibility: 'hidden' });
                $('#mapBaidu').css({ display: 'block', visibility: 'visible' });
                $('.js-map').addClass('cc-active');
                $('.js-img').removeClass('cc-active');
                $('.cc-maps-icon').attr('xlink:href', mapfill);
                $('.cc-gallery-icon').attr('xlink:href', galleryStroke);
            }
        });
        $(document).on('click', '.js-img', function () {
            if (!$('.js-img').hasClass('cc-active')) {
                $('.cc-images-only-mobile-visible').css({ display: 'block', visibility: 'visible' });
                $('#mapBaidu').css({ display: 'none', visibility: 'hidden' });
                $('.js-img').addClass('cc-active');
                $('.js-map').removeClass('cc-active');
                $('.cc-gallery-icon').attr('xlink:href', galleryFill);
                $('.cc-maps-icon').attr('xlink:href', mapStroke);
            }
        });
    }
};
